// src/services/emailApi.js

const API_BASE_URL = 'https://vcwnmz9aj0.execute-api.ap-southeast-2.amazonaws.com/Prod';

export const sendEmailWithAttachment = async (to, subject, body, attachment, isHtml = false) => {
  try {
    let base64Attachment;

    if (isHtml) {
      // For HTML content, we can directly encode it to base64
      base64Attachment = btoa(unescape(encodeURIComponent(attachment)));
    } else {
      // For file attachments, use FileReader as before
      const reader = new FileReader();
      reader.readAsDataURL(attachment);
      base64Attachment = await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result.split(',')[1]); // Remove data URL prefix
        reader.onerror = (error) => {
          console.error('Error converting file to base64:', error);
          reject(error);
        };
      });
    }

    const formData = new FormData();
    formData.append('to', to);
    formData.append('subject', subject);
    formData.append('body', body);
    formData.append('attachment', base64Attachment);
    formData.append('filename', isHtml ? 'quote_summary.html' : attachment.name);
    formData.append('contentType', isHtml ? 'text/html' : attachment.type);

    const response = await fetch(`${API_BASE_URL}/email-sow`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
